// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"ce5eecca","48":"93a3c001","390":"cc383e3f","419":"7abb301d","563":"d382ed58","842":"f7ff9281","942":"ea98f437"}[chunkId] + ".chunk.js";
};